import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { ReactLenis } from "lenis/react";
import "lenis/dist/lenis.css";

// Components
import { Header } from "@/components/Header";
import { Hero } from "@/components/Hero";
import { MarqueeTicker } from "@/components/MarqueeTicker";
import { Manifesto } from "@/components/Manifesto";
import { Episodes } from "@/components/Episodes";
import { QuoteCards } from "@/components/QuoteCards";
import { About } from "@/components/About";
import { ChaosQuiz } from "@/components/ChaosQuiz";
import { StudioRental } from "@/components/StudioRental";
import { GuestApplication } from "@/components/GuestApplication";
import { Newsletter } from "@/components/Newsletter";
import { Footer } from "@/components/Footer";
import { CupcakeEasterEgg } from "@/components/CupcakeEasterEgg";

// Admin Pages
import AdminLogin from "@/pages/AdminLogin";
import AdminDashboard from "@/pages/AdminDashboard";

const Home = () => {
  return (
    <ReactLenis root options={{ anchors: true, lerp: 0.09 }}>
      <div className="min-h-screen bg-[#08080D] text-[#F4F2EE]">
        <div className="noise-overlay" />
        <Header />
        <main>
          <Hero />
          <MarqueeTicker />
          <Manifesto />
          <Episodes />
          <QuoteCards />
          <About />
          <ChaosQuiz />
          <StudioRental />
          <GuestApplication />
          <Newsletter />
        </main>
        <Footer />
        <CupcakeEasterEgg />
      </div>
    </ReactLenis>
  );
};

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/admin" element={<AdminLogin />} />
          <Route path="/admin/dashboard" element={<AdminDashboard />} />
        </Routes>
      </BrowserRouter>
    </div>
  );
}

export default App;
